import styled from 'styled-components';

export const ErrorMessage = styled.p`
  color: red;
  padding-top: 10px;
`;

export const FormWrapper = styled.div`
  max-width: 500px;
`;

export const Spacer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const StyledLabel = styled.span`
  display: flex;
  width: 100%;
`;

export const AmountLabel = styled.span`
  margin-right: 4px;
`;

export const AccountCardWrapper = styled.div`
  & + & {
    margin-top: 18px;
  }
`;
